import {
  Component,
  effect,
  EventEmitter,
  HostListener,
  inject,
  Input,
  model,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ProductInterface,
  ProviderProductInterface,
  ProviderProductVariantInterface,
} from '../../../../core/interfaces/product/product';
import {
  ProviderGroupEnum,
  providerSettingsInterface,
} from '@component-library';
import { StoreInterface } from '../../../../core/interfaces/store/store-interface';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SharedModule } from 'primeng/api';
import { Table, TableModule } from 'primeng/table';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { VariantsMatchingComponent } from '../../../variants/matching/variants-matching.component';
import {
  ProductClass,
  Value,
  VariantItem,
} from '../../../../core/classes/product/product';
import { ProviderCategoryAttributesService } from '../../../../core/services/categories/provider-category-attributes.service';
import { RedisProviderCategoryAttributeRootInterface } from '../../../../core/interfaces/categories/provider-category-attributes-interface';

import { TuiFilterPipeModule } from '@taiga-ui/cdk';
import {
  UniqVariantList,
  VariantProviderCategoryInterface,
  VariantsInterface,
} from '../../../../core/interfaces/variants/variants-interface';
import { StyleClassModule } from 'primeng/styleclass';
import { ProviderProductClass } from '../../../../core/classes/provider-product/provider-product';
import { IdentityEnum } from '../../../../core/enums/Providers/identity-enum';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { VariantsService } from '../../../../core/services/variants/variants.service';
import { MessagesModule } from 'primeng/messages';
import { StoreService } from '../../../../core/store/store.service';
import { Subject, takeUntil } from 'rxjs';
import { Select } from 'primeng/select';
import { InputGroupAddon } from 'primeng/inputgroupaddon';
import { InputGroup } from 'primeng/inputgroup';
import { Message } from 'primeng/message';
import { GlobalMessageService } from '../../../../core/services/global-services/global-message-service/global-message.service';

export interface datasourceInterface {
  code: string;
  productVariantItem: VariantItem;
  providerProductVariantList: UniqVariantList[];
  matching: boolean;
  catalogId?: string;
}

@Component({
  selector: 'magenty-provider-product-detail-variants',
  imports: [
    CommonModule,
    ButtonModule,
    ChipModule,
    FormsModule,
    InputTextModule,
    SharedModule,
    TableModule,
    TuiFilterPipeModule,
    StyleClassModule,
    RadioButtonModule,
    TooltipModule,
    SelectButtonModule,
    CheckboxModule,
    MessagesModule,
    Select,
    InputGroupAddon,
    InputGroup,
    Message,
  ],
  templateUrl: './provider-product-detail-variants.component.html',
  styleUrl: './provider-product-detail-variants.component.scss',
})
export class ProviderProductDetailVariantsComponent
  implements OnInit, OnDestroy
{
  variantsService = inject(VariantsService);
  storeService = inject(StoreService);
  globalMessageService = inject(GlobalMessageService);
  @Input() product: ProductInterface = new ProductClass(
    this.storeService.store$()
  );
  @Input() providerProduct: ProviderProductInterface = new ProviderProductClass(
    this.storeService.store$()
  );
  @Input() providerSettings: providerSettingsInterface | undefined;
  store: StoreInterface;
  @Input() eachVariantAProduct: boolean | undefined = false;
  @Output() variantDataSource = new EventEmitter<datasourceInterface[]>();
  @Output() baseVariants = new EventEmitter<VariantsInterface[]>();

  matchingAutoComplete = model({
    brand: false,
    category: false,
    attribute: false,
    variant: false,
  });

  variantMatchinRef: DynamicDialogRef | undefined;
  productVariantItemList: VariantItem[] = [];

  providerCategoryAttributes = model<
    RedisProviderCategoryAttributeRootInterface[]
  >([]);

  private destroy$ = new Subject<void>();
  datasource: datasourceInterface[] = [];
  selectedVariantItem: datasourceInterface[] = [];
  providerProductVariantList: ProviderProductVariantInterface[] = [];
  readonly matcher = (details: Value, search: string): boolean =>
    details.Key === search;

  windowWidth = 0;
  validationSetTimeId: any;
  messages: { severity: string; detail: string }[] = [];
  isAutoMatching = false;

  constructor(
    public ref: DynamicDialogRef,
    private dialogService: DialogService,
    private providerCategoryAttributesService: ProviderCategoryAttributesService
  ) {
    this.store = this.storeService.store$();

    effect(() => {
      this.store = this.storeService.store$();
    });

    effect(() => {
      if (this.providerProduct) {
        this.providerProductVariantList = this.providerProduct.getVariantList();
        this.productVariantItemList =
          this.providerProduct.getProductVariantList();
      }

      if (
        this.datasource.length === 0 &&
        this.providerSettings?.providerGroup !== ProviderGroupEnum.ECommerce
      ) {
        this.createDataSource();
      }
    });
    this.windowWidth = window.outerWidth;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: { target: { innerWidth: number } }) {
    this.windowWidth = event.target.innerWidth;
  }

  ngOnInit() {
    if (this.providerSettings?.providerGroup === ProviderGroupEnum.ECommerce) {
      this.refreshVariants();
    }
  }

  refreshVariants = (isRefresh?: boolean) => {
    if (this.providerProduct) {
      this.providerProductVariantList = this.providerProduct.getVariantList();
      this.productVariantItemList =
        this.providerProduct.getProductVariantList();

      this.providerCategoryAttributesService
        .getList({
          ProviderId: this.providerProduct.ProviderId,
          CategoryCode: this.providerProduct.Category,
          MarketplaceIdentity: this.providerProduct.MarketplaceIdentity,
          IsRefresh: isRefresh,
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.providerCategoryAttributes.set(res);
          this.createDataSource();
          if (isRefresh) {
            this.globalMessageService.showStatusMessages({
              status: true,
              summary: 'Varyant Yenile',
              infoDetail: 'Varyant değerlerini yenileme işlemi başarılı.',
              errorDetail: 'Varyant değerlerini yenileme işlemi başarılı.',
            });
          }
        });
    }
  };

  createDataSource = () => {
    this.datasource = [];
    this.productVariantItemList.map((productVariantItem) => {
      const tempProviderProductVariantList: UniqVariantList[] = [];
      const filteredVariantList = this.providerProductVariantList.filter(
        (f) => f.VariantItemCode === productVariantItem.Code
      );

      filteredVariantList.map((variant) => {
        const variantItem: UniqVariantList = {
          Name: variant.Name,
          lowercaseName: variant.Name.toLocaleLowerCase(),
          NameId: variant.NameId,
          Value: variant.Value,
          lowercaseValue: variant.Value.toLocaleLowerCase(),
          ValueId: variant.ValueId,
          Details: variant.Details,
          Values: [],
          VariantValue:
            variant.Details.find((f) => f.Key === 'VariantValue')?.Value ?? '',
          VariantKey:
            variant.Details.find((f) => f.Key === 'VariantKey')?.Value ?? '',
          NameMatchin: false,
          ValueMatchin: false,
        };

        if (this.providerSettings?.Variant.sendOurVariant) {
          variantItem.NameId = variantItem.VariantKey;
          variantItem.ValueId = variantItem.VariantValue;

          variantItem.Name = variantItem.VariantKey;
          variantItem.Value = variantItem.VariantValue;

          variantItem.lowercaseName =
            variantItem.VariantKey.toLocaleLowerCase();
          variantItem.lowercaseValue =
            variantItem.VariantValue.toLocaleLowerCase();

          variantItem.NameMatchin = true;
          variantItem.ValueMatchin = true;
        } else {
          const foundName = this.providerCategoryAttributes().find(
            (f) => f.lowercaseName === variant.Name.toLocaleLowerCase()
          );
          let foundValue = false;
          if (foundName) {
            if (foundName.Values.length > 0) {
              foundValue =
                foundName.Values.find(
                  (f: any) =>
                    f.lowercaseValue === variant.Value.toLocaleLowerCase()
                ) !== undefined;
            } else {
              foundValue = true;
            }
          }

          variantItem.Values = foundName?.Values ?? [];
          variantItem.NameMatchin = foundName !== undefined;
          variantItem.ValueMatchin = foundValue;
        }

        tempProviderProductVariantList.push(variantItem);
      });

      const tempDatasource = {
        code: productVariantItem.Code,
        productVariantItem: productVariantItem,
        providerProductVariantList: tempProviderProductVariantList,
        matching: this.matchingStatus(tempProviderProductVariantList),
        catalogId: '',
      };

      if (this.providerProduct.MarketplaceIdentity === IdentityEnum.N11) {
        tempDatasource.catalogId =
          tempDatasource?.providerProductVariantList
            ?.at(0)
            ?.Details?.find((f) => f.Key === 'CatalogId')?.Value ?? '';
      }

      this.datasource.push(tempDatasource);
    });

    this.variantDataSource.emit(this.datasource);

    this.selectedVariantItem = [...this.datasource];

    if (this.providerProduct.Id.length === 0) {
      const dataSourceProviderProducts = this.datasource.map(
        (data) => data.providerProductVariantList
      );
      const filteredVariantItems = dataSourceProviderProducts.filter(
        (variant) => {
          return variant.some((v) => v.Value.length === 0);
        }
      );

      if (filteredVariantItems.length > 0) {
        this.getVariantsCategories();
      }
    }

    this.validation();
  };

  getVariantsCategories = () => {
    const filteredCategories: VariantProviderCategoryInterface[] = [];

    this.variantsService
      .getAll(false)
      .pipe(takeUntil(this.destroy$))
      .subscribe((baseVariants) => {
        if (baseVariants) {
          this.baseVariants.emit(baseVariants);

          baseVariants.map((variant) => {
            variant.Values.map((value) => {
              value.ProviderCategories?.map((proCategory) => {
                if (
                  proCategory.MarketplaceIdentity ===
                    this.providerProduct.MarketplaceIdentity &&
                  proCategory.ProviderId === this.providerProduct.ProviderId &&
                  proCategory.ProviderCategory === this.providerProduct.Category
                ) {
                  filteredCategories.push(proCategory);
                }
              });
            });
          });

          this.variantAutoMatching(filteredCategories);
        }
      });
  };

  variantAutoMatching = (
    filteredCategories: VariantProviderCategoryInterface[]
  ) => {
    if (filteredCategories.length === 0) {
      this.setMatchingStatus(false);
      return;
    }

    this.datasource.map((data) => {
      data.providerProductVariantList.map((variant) => {
        const variantKey = variant.Details.find(
          (detail) => detail.Key === 'VariantKey'
        )?.Value.toLocaleLowerCase();
        const variantValue = variant.Details.find(
          (detail) => detail.Key === 'VariantValue'
        )?.Value.toLocaleLowerCase();

        const found = filteredCategories.find(
          (provCat) =>
            provCat.Attribute.Value.toLocaleLowerCase() === variantValue &&
            provCat.Attribute.Name.toLocaleLowerCase() === variantKey
        );

        if (found) {
          variant.Name = found.Attribute.Name;
          variant.lowercaseName = found.Attribute.Name.toLocaleLowerCase();
          variant.lowercaseValue = found.Attribute.Value.toLocaleLowerCase();
          variant.NameId = found.Attribute.NameId;
          variant.Value = found.Attribute.Value;
          variant.ValueId = found.Attribute.ValueId;
        }
      });
    });

    this.setMatchingStatus(true);

    this.featureMatch();
    this.validation();
  };

  setMatchingStatus = (status: boolean) => {
    this.matchingAutoComplete().variant = status;

    if (this.isAutoMatching) {
      this.messagesFill();
    }
  };

  messagesFill = () => {
    this.messages = [
      {
        severity: 'success',
        detail: 'Varyant değerleri otomatik olarak eşleştirildi',
      },
    ];
  };

  featureMatch = () => {
    this.datasource.map((data: datasourceInterface) => {
      if (!data.matching) {
        data.providerProductVariantList.map((variantItem) => {
          if (!variantItem.NameMatchin) {
            const found = this.providerCategoryAttributes().find(
              (f) => f.lowercaseName === variantItem.VariantKey.toLowerCase()
            );
            if (found) {
              variantItem.Name = found.Name;
              variantItem.lowercaseName = found.lowercaseName;
              variantItem.NameId = found.Code;
              variantItem.NameMatchin = true;
              variantItem.Values = found.Values;
            }
          }
          if (!variantItem.ValueMatchin) {
            if (variantItem.Values.length > 0) {
              const found = variantItem.Values.find(
                (f) =>
                  f.lowercaseValue ===
                  variantItem.VariantValue.toLocaleLowerCase()
              );
              if (found) {
                variantItem.ValueMatchin = true;
                variantItem.Value = found.Value;
                variantItem.lowercaseValue = found.lowercaseValue;
                variantItem.ValueId = found.Key;
              }
            } else {
              variantItem.ValueMatchin = true;
              variantItem.Value = variantItem.VariantValue;
              variantItem.ValueId = variantItem.VariantValue;
              variantItem.lowercaseValue =
                variantItem.VariantValue.toLocaleLowerCase();
            }
          }
        });

        data.matching = this.matchingStatus(data.providerProductVariantList);
      }
    });
    this.validation();
  };

  clearMatch = () => {
    this.datasource.map((data: datasourceInterface) => {
      data.providerProductVariantList.map((variantItem) => {
        variantItem.Name = '';
        variantItem.NameId = '';
        variantItem.lowercaseName = '';
        variantItem.Value = '';
        variantItem.ValueId = '';
        variantItem.lowercaseValue = '';
        variantItem.Values = [];
        variantItem.ValueMatchin = false;
        variantItem.NameMatchin = false;
      });
      data.matching = false;
    });
    this.validation();
  };

  changeName = (
    event: string,
    variantItem: UniqVariantList,
    rowData: datasourceInterface
  ) => {
    const found = this.providerCategoryAttributes().find(
      (f) => f?.lowercaseName === event
    );
    if (found) {
      variantItem.Name = found.Name;
      variantItem.lowercaseName = found.Name.toLowerCase();
      variantItem.NameId = found.Code;
      variantItem.Values = found.Values;
      variantItem.NameMatchin = true;
      variantItem.ValueMatchin = false;
      variantItem.Value = '';
      variantItem.ValueId = '';
      variantItem.lowercaseValue = '';

      if (rowData) {
        rowData.matching = this.matchingStatus(
          rowData.providerProductVariantList
        );
      }
    }
    this.validation();
  };

  changeValue = (
    event: string,
    variantItem: UniqVariantList,
    rowData: datasourceInterface
  ) => {
    if (variantItem) {
      if (variantItem.Values.length > 0) {
        const found = variantItem.Values.find(
          (f) => f.lowercaseValue === event
        );
        if (found) {
          variantItem.ValueId = found.Key;
          variantItem.Value = found.Value;
          variantItem.lowercaseValue = event;
        }
      } else {
        variantItem.ValueId = event;
        variantItem.Value = event;
        variantItem.lowercaseValue = event.toLocaleLowerCase();
      }
      variantItem.ValueMatchin = event.length > 0;

      if (rowData) {
        rowData.matching = this.matchingStatus(
          rowData.providerProductVariantList
        );
      }
      this.setMatchingStatus(false);
    }
    this.validation();
  };

  openVariantMatching = () => {
    this.variantMatchinRef = this.dialogService.open(
      VariantsMatchingComponent,
      {
        header: `Varyant Karşılığını Eşleştirme`,
        width: '50vw',
        modal: true,
        closable: true,
        data: {
          product: this.product,
          providerProduct: this.providerProduct,
        },
        breakpoints: {
          '960px': '70vw',
          '640px': '90vw',
        },
      }
    );
    this.variantMatchinRef.onClose
      .pipe(takeUntil(this.destroy$))
      .subscribe((f: UniqVariantList[]) => {
        if (f) {
          this.datasource.map((data) => {
            data.providerProductVariantList.map((variantList) => {
              const found = f.find(
                (f) =>
                  f.VariantKey === variantList.VariantKey &&
                  f.VariantValue === variantList.VariantValue
              );
              if (found) {
                if (found.NameMatchin && !variantList.NameMatchin) {
                  variantList.Name = found.Name;
                  variantList.lowercaseName = found.lowercaseName;
                  variantList.NameId = found.NameId;
                  variantList.NameMatchin = true;
                  variantList.Value = '';
                  variantList.ValueId = '';
                  variantList.lowercaseValue = '';
                  variantList.ValueMatchin = false;
                }

                if (found.ValueMatchin && !variantList.ValueMatchin) {
                  variantList.Value = found.Value;
                  variantList.ValueId = found.ValueId;
                  variantList.lowercaseValue = found.lowercaseValue;
                  variantList.ValueMatchin = true;
                }
                if (
                  (found.NameMatchin && !variantList.NameMatchin) ||
                  (found.ValueMatchin && !variantList.ValueMatchin)
                ) {
                  variantList.Values = found.Values;
                }
              }
            });
            data.matching = this.matchingStatus(
              data.providerProductVariantList
            );
          });
        }
        this.validation();
      });
  };

  matchingStatus = (variantList: UniqVariantList[]) => {
    if (variantList) {
      return variantList.every((f) => f.ValueMatchin && f.NameMatchin);
    }
    return false;
  };

  clear(table: Table) {
    table.clear();
    this.validation();
  }

  changeCatalogId = (rowData: datasourceInterface, event: any) => {
    rowData.providerProductVariantList.map((f) => {
      const found = f.Details.find((x) => x.Key === 'CatalogId');
      if (found) {
        found.Value = event ?? '';
      } else {
        f.Details.push({ Key: 'CatalogId', Value: event ?? '' });
      }
    });
  };

  validation = () => {
    if (!this.providerProduct) return;
    this.providerProduct.Variants = [];
    this.selectedVariantItem.map((selected) => {
      selected.providerProductVariantList.map((variantList) => {
        this.providerProduct?.Variants.push({
          Details: variantList?.Details,
          Name: variantList?.Name ?? '',
          NameId: variantList.NameId ?? '',
          Value: variantList?.Value ?? '',
          ValueId: variantList.ValueId ?? '',
          VariantItemCode: selected.productVariantItem.Code,
        });
      });
    });

    clearTimeout(this.validationSetTimeId);
    this.validationSetTimeId = setTimeout(() => {
      this.providerProduct?.validationFunction(
        this.providerCategoryAttributes()
      );
    }, 100);
  };
  protected readonly IdentityEnum = IdentityEnum;
}
